export default __webpack_public_path__ + "static/media/plus.f8c5aede.png";